export default "/images/OncLive.png?4419e7a28ccd962c2875a6f0e93d3a4e";